import {
  activeStepperDelay,
  inactiveStepperDuration,
  stepCard,
  stepContent,
  stepLine,
  stepLineTextStyles,
  stepLineVertical,
  stepNum,
  stepper,
  stepperDelay,
  stepperDuration,
  stepperLineWidth,
  stepperVars,
} from './stepper.styles';

export const StepperStyles = {
  activeStepperDelay,
  inactiveStepperDuration,
  stepCard,
  stepContent,
  stepLine,
  stepLineTextStyles,
  stepLineVertical,
  stepNum,
  stepper,
  stepperDelay,
  stepperDuration,
  stepperLineWidth,
  stepperVars,
};
